/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliPeriodDto } from '../../models/amoxcalli-period-dto';

export interface ApiCyclesCycleIdPeriodsGet$Json$Params {
  cycleId: string;
}

export function apiCyclesCycleIdPeriodsGet$Json(http: HttpClient, rootUrl: string, params: ApiCyclesCycleIdPeriodsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliPeriodDto>>> {
  const rb = new RequestBuilder(rootUrl, apiCyclesCycleIdPeriodsGet$Json.PATH, 'get');
  if (params) {
    rb.path('cycleId', params.cycleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliPeriodDto>>;
    })
  );
}

apiCyclesCycleIdPeriodsGet$Json.PATH = '/api/cycles/{cycleId}/periods';
